import { render, staticRenderFns } from "./TgMemberPrivilegeBulkDialog.vue?vue&type=template&id=fd2af5a8"
import script from "./TgMemberPrivilegeBulkDialog.vue?vue&type=script&lang=js"
export * from "./TgMemberPrivilegeBulkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports